export type OnboardingDoneOn = 'anchor-click' | 'manual';
export interface OnboardingScreen {
  id: string;
  title: string;
  urlPattern: string;
}
/** Выключатель ролика. По умолчанию ролик, обложка и длительность адресуются по id записи (`OnboardingMediaService`). */
export interface OnboardingVideo {
  enabled: boolean;
  /**
   * Своего ролика у записи нет — карточка показывает ролик названного урока. Названного ролика нет
   * в манифесте — карточка остаётся без видео, как и любая другая ненаснятая.
   */
  lesson?: string;
}
/**
 * Кнопка карточки коуча. Карточка с кнопками рисует и текст записи. Главная кнопка проходит запись и
 * отдаёт хосту действие (`OnboardingService.coachAction`), любая другая скрывает её, как крестик.
 */
export interface CoachAction {
  label: string;
  primary?: boolean;
}
export interface OnboardingRecord {
  id: string;
  /** Экран, где запись встаёт в очередь. Экран шире текущего (весь проект) ставит её в очередь каждого экрана под ним. */
  screen: string;
  /**
   * `aside` — на якоре этой записи открывается своё окно, и карточка встаёт СБОКУ от него: иначе окно
   * закрывало бы её собой. Без флага карточка стоит у самого якоря.
   */
  coach?: { title: string; body: string; aside?: boolean; actions?: CoachAction[] };
  video: OnboardingVideo;
  doneOn: OnboardingDoneOn;
  /** Подсказка ждёт своей очереди: молчит, пока названная запись не пройдена и не скрыта. */
  after?: string;
  /** Карточка только по просьбе: обход экрана её минует, поднимает её один `requestHint`. */
  onRequest?: boolean;
}
/**
 * Урок, ролик которого показывает карточка записи: названный каталогом чужой, иначе свой id. Всё
 * остальное — прогресс, якоря, очередь подсказок — по-прежнему адресуется id самой записи.
 */
export function clipLessonId(record: OnboardingRecord): string {
  return record.video.lesson ?? record.id;
}

export interface OnboardingCatalog {
  screens: OnboardingScreen[];
  records: OnboardingRecord[];
}
/** Урок плейлиста. */
export interface PlaylistLesson {
  id: string;
  title: string;
  description: string;
}
export interface PlaylistGroup {
  title: string;
  lessons: PlaylistLesson[];
}
/**
 * Список уроков окна: разделы, порядок, названия и тексты приезжают из спеки через синк с публикацией,
 * релиз приложения для этого не нужен. Каналы поддержки в плейлисте не живут — их адреса вшиты в код
 * (`support-channels.ts`), поэтому лишний ключ файла здесь никто не читает.
 */
export interface Playlist {
  groups: PlaylistGroup[];
}
export interface LibraryRequest {
  lessonId: string | null;
  seq: number;
  /** Фотограф позвал именно этот ролик — он и заводится сам; открытое иначе окно стоит на постере (R41). */
  autoplay: boolean;
}
export interface ActiveHint {
  record: OnboardingRecord;
  /**
   * Место карточки. Якорь записи внутри раскрываемого контейнера (меню, поповер) — здесь стоит сам
   * вход в него (кебаб, «Действия»): карточка указывает на вход и в меню не заезжает (R44).
   */
  element: HTMLElement;
}
